import Cache from 'root/cache';
import UI from 'root/ui';
import View from 'view/base';
import View_Slack from 'view/integration/slack';
import View_Teams from 'view/integration/teams';
import View_Jira from 'view/integration/jira';
import View_Teamwork from 'view/integration/teamwork';
import View_Trello from 'view/integration/trello';
import View_Basecamp from 'view/integration/basecamp';
import View_Asana from 'view/integration/asana';
import View_Clickup from 'view/integration/clickup';
import View_Monday from 'view/integration/monday';
import View_Notion from 'view/integration/notion';
import View_Wrike from 'view/integration/wrike';
import View_Azure_Devops from 'view/integration/azure_devops';
import View_Linear from 'view/integration/linear';
import View_Github from 'view/integration/github';
import View_Gitlab from 'view/integration/gitlab';
import View_Zendesk from 'view/integration/zendesk';
import View_Webhook from 'view/integration/webhook';
import View_Zapier from 'view/integration/zapier';
import View_Wordpress from 'view/integration/wordpress';
import View_Intercom from 'view/integration/intercom';

export default View.extend({
    tagName: 'section',

    views: {
        slack        : {},
        teams        : {},
        jira         : {},
        teamwork     : {},
        trello       : {},
        basecamp     : {},
        asana        : {},
        clickup      : {},
        monday       : {},
        notion       : {},
        wrike        : {},
        azure_devops : {},
        github       : {},
        gitlab       : {},
        linear       : {},
        zendesk      : {},
        webhook      : {},
        zapier       : {},
        wordpress    : {},
        intercom     : {}
    },

    initialize: function () {
        this.views.slack        = new View_Slack();
        this.views.teams        = new View_Teams();
        this.views.webhook      = new View_Webhook();

        if (Cache.getDefaultProject().isFeedback()) {
            this.views.jira         = new View_Jira();
            this.views.teamwork     = new View_Teamwork();
            this.views.trello       = new View_Trello();
            this.views.basecamp     = new View_Basecamp();
            this.views.asana        = new View_Asana();
            this.views.clickup      = new View_Clickup();
            this.views.monday       = new View_Monday();
            this.views.notion       = new View_Notion();
            this.views.wrike        = new View_Wrike();
            this.views.azure_devops = new View_Azure_Devops();
            this.views.github       = new View_Github();
            this.views.gitlab       = new View_Gitlab();
            this.views.linear       = new View_Linear();
            this.views.zendesk      = new View_Zendesk();
            this.views.zapier       = new View_Zapier();
            this.views.wordpress    = new View_Wordpress();
            this.views.intercom     = new View_Intercom();
        }

        this.connected    = [];
        this.disconnected = [];

        [
            {
                model: Cache.integration_slack.findWhere({project_id: Cache.default_project_id}),
                view: this.views.slack
            },
            {
                model: Cache.integration_teams.findWhere({project_id: Cache.default_project_id}),
                view: this.views.teams
            },
            {
                model: Cache.integration_jira.findWhere({project_id: Cache.default_project_id}),
                view: this.views.jira
            },
            {
                model: Cache.integration_clickup.findWhere({project_id: Cache.default_project_id}),
                view: this.views.clickup
            },
            {
                model: Cache.integration_asana.findWhere({project_id: Cache.default_project_id}),
                view: this.views.asana
            },
            {
                model: Cache.integration_notion.findWhere({project_id: Cache.default_project_id}),
                view: this.views.notion
            },
            {
                model: Cache.integration_teamwork.findWhere({project_id: Cache.default_project_id}),
                view: this.views.teamwork
            },
            {
                model: Cache.integration_trello.findWhere({project_id: Cache.default_project_id}),
                view: this.views.trello
            },
            {
                model: Cache.integration_github.findWhere({project_id: Cache.default_project_id}),
                view: this.views.github
            },
            {
                model: Cache.integration_basecamp.findWhere({project_id: Cache.default_project_id}),
                view: this.views.basecamp
            },
            {
                model: Cache.integration_monday.findWhere({project_id: Cache.default_project_id}),
                view: this.views.monday
            },
            {
                model: Cache.integration_wrike.findWhere({project_id: Cache.default_project_id}),
                view: this.views.wrike
            },
            {
                model: Cache.integration_azure_devops.findWhere({project_id: Cache.default_project_id}),
                view: this.views.azure_devops
            },
            {
                model: Cache.integration_linear.findWhere({project_id: Cache.default_project_id}),
                view: this.views.linear
            },
            {
                model: Cache.integration_gitlab.findWhere({project_id: Cache.default_project_id}),
                view: this.views.gitlab
            },
            {
                model: Cache.integration_webhook.findWhere({project_id: Cache.default_project_id}),
                view: this.views.webhook
            },
            {
                model: Cache.integration_zendesk.findWhere({project_id: Cache.default_project_id}),
                view: this.views.zendesk
            }
        ].forEach((integration, key) => {
            if (integration.view instanceof View) {
                if (integration.model && integration.model.isConnected()) {
                    this.connected.push(integration.view);
                } else {
                    this.disconnected.push(integration.view);
                }
            }
        });

        if (Cache.getDefaultProject().isFeedback()) {
            this.disconnected.push(this.views.intercom);
            this.disconnected.push(this.views.zapier);
            this.disconnected.push(this.views.wordpress);
        }

        // order by recommended
        this.connected.sort((a, b) => {
            return a.isRecommended && a.isRecommended() ? -1 : 1;
        });

        this.disconnected.sort((a, b) => {
            return a.isRecommended && a.isRecommended() ? -1 : 1;
        });
    },

    render: function () {
        UI.setPageTitle('Connect');

        var content = '<main class="large"></main>';

        this.$el.html(content);

        this.connected.forEach((view) => {
            view.render().$el.appendTo(this.$el.find('main'));
        });

        this.disconnected.forEach((view) => {
            view.render().$el.appendTo(this.$el.find('main'));
        });

        return this;
    }
});
